import React from 'react';
import {Route} from 'react-router-dom';
import Home from './pages/Home';
import ContactInfo from './pages/ContactInfo';
import {
  BusinessInfoCoverageArea,
  BusinessInfoDetails,
  BusinessInfoDisplayName,
  BusinessInfoTrades
} from './pages/BusinessInfo';
import {
  TaxInfo,
  TaxInfoAddress,
  TaxInfoBusiness,
  TaxInfoEIN,
  TaxInfoIndividual,
  TaxInfoReview,
  TaxInfoSocialSecurityInd
} from './pages/TaxInfo';
import AppWrapper from './components/general/AppWrapper';
import LandingPage from './pages/LandingPage';
import TitleHeader from './components/general/TitleHeader/TitleHeader';
import ErrorBox from './components/general/ErrorBox/ErrorBox';
import ContactInfoSMS from './pages/ContactInfoSMS';
import ErrorProvider from './context/ErrorProvider';
import BankingInfo from "./pages/BankingInfo";
import {ContractorAgreement} from "./pages/Documents/ContractorAgreement";
import IncorrectEmail from "./pages/IncorrectEmail";
import EmailVerified from "./pages/EmailVerified";
import LinkExpired from "./pages/LinkExpired";

const App = (): React.ReactElement => {
  return (
    <ErrorProvider>
      <TitleHeader/>
      <ErrorBox/>
      <AppWrapper>
        <Route element={<Home/>} path=""/>
        <Route element={<EmailVerified/>} path="/email-verified"/>
        <Route element={<LinkExpired/>} path="/link-expired"/>
        <Route path="contractors/:applicationID">
          <Route index element={<LandingPage/>}/>
          <Route element={<Home/>} path="steps"/>
          <Route element={<IncorrectEmail/>} path="incorrect-email"/>
          <Route element={<ContactInfo/>} path="contact-info"/>
          <Route element={<ContactInfoSMS/>} path="contact-info/sms"/>
          <Route element={<BusinessInfoDisplayName/>} path="business-info/1"/>
          <Route element={<BusinessInfoDetails/>} path="business-info/2"/>
          <Route element={<BusinessInfoCoverageArea/>} path="business-info/3"/>
          <Route element={<BusinessInfoTrades/>} path="business-info/4"/>
          <Route element={<TaxInfo/>} path="tax-info"/>
          // individual
          <Route element={<TaxInfoIndividual/>} path="tax-info/individual"/>
          <Route element={<TaxInfoAddress path="individual"/>} path="tax-info/individual/address"/>
          <Route element={<TaxInfoSocialSecurityInd/>} path="tax-info/individual/social-security"/>
          <Route element={<TaxInfoReview/>} path="tax-info/individual/review"/>
          // business
          <Route element={<TaxInfoBusiness/>} path="tax-info/business"/>
          <Route element={<TaxInfoAddress path="business"/>} path="tax-info/business/address"/>
          <Route element={<TaxInfoEIN/>} path="tax-info/business/ein"/>
          <Route element={<TaxInfoReview/>} path="tax-info/business/review"/>
          // contracts
          <Route element={<ContractorAgreement/>} path="documents/contractor-agreement"/>
          // Payment
          <Route element={<BankingInfo/>} path="banking-info"/>
        </Route>
      </AppWrapper>
    </ErrorProvider>
  );
};

export default App;
